// extracted by mini-css-extract-plugin
export default {"lds-ring":"spinner_lds-ring__+EXdr"};